var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h3',[_vm._v("hello")]),_c('router-link',{attrs:{"to":"/home"}},[_vm._v("home")]),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("about")]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }